import { createStore, applyMiddleware } from "redux";
import rootReducer from "../../reducers";

// Inlined to avoid redux-thunk ESM/CJS resolution failure under webpack prod terser
const thunkMiddleware = ({ dispatch, getState }) => next => action => {
  if (typeof action === "function") return action(dispatch, getState);
  return next(action);
};

const middleware = applyMiddleware(thunkMiddleware);
export const store = createStore(rootReducer, middleware);
